const JsSimpleHeader = {
	init () {

		/*
		* Simple Header
		*/

		// We have UX issues with this filter setup, if it's going to remain as is, 
		// the least we can do is not show the date filtering until something is available in the search box, 
		// or at least disable the input
		if ( $('.c-simple-header-filter-columns').length ) {

			let search = $('.c-simple-header__search').find('input').val();

			if ( search == "" ) {
		    	$('.dropdown-button').addClass('hide');
		    	$('.date-filter').addClass('hide');
		    	$('.c-simple-header-search-columns').addClass('large-7');
		    	$('.c-simple-header-search-columns').removeClass('large-4');
		    } else {
		    	$('.dropdown-button').removeClass('hide');
		    	$('.date-filter').removeClass('hide');
		    	$('.c-simple-header-search-columns').removeClass('large-7');
		    	$('.c-simple-header-search-columns').addClass('large-4');
		    }

			$('.c-simple-header__search').find('input').keyup(function() {
			    search = $(this).val();

			    if ( search == "" ) {
			    	$('.dropdown-button').addClass('hide');
			    	$('.date-filter').addClass('hide');
			    	$('.c-simple-header-search-columns').addClass('large-7');
			    	$('.c-simple-header-search-columns').removeClass('large-4');
			    } else {
			    	$('.dropdown-button').removeClass('hide');
			    	$('.date-filter').removeClass('hide');
			    	$('.c-simple-header-search-columns').removeClass('large-7');
			    	$('.c-simple-header-search-columns').addClass('large-4');
			    	console.log("Remove 7 add 4")
			    }
			});
		}
	}
};

export default JsSimpleHeader;


// WEBPACK FOOTER //
// ./src/components/03-ui/simple-header/simple-header.js